import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss']
})
export class InputSearchComponent implements OnInit, OnChanges {
  @Input() defaultValue?: string;
  @Input() name?: string;
  @Input() placeholder?: string = 'search';
  @Input() controlledValue?: string;
  @Input() mobileMode = false;
  @Input() size: 'normal' | 'large' = 'normal';
  @Input() theme: 'light' | 'dark-grey' = 'dark-grey';
  @Input() numberInput = false;
  @Input() showMinLengthIcon = true;
  @Output() searchValue = new EventEmitter<string>();

  public searchInputModel = '';
  public searchInput = new Subject<string>();

  private unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    if (typeof this.defaultValue === 'string') {
      this.searchInputModel = this.defaultValue;
    }
    if (typeof this.controlledValue === 'string') {
      this.searchInputModel = this.controlledValue;
    }

    this.searchInput.pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.unsubscribe$)).subscribe(val => this.searchValue.emit(val.trim()));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      typeof changes.controlledValue?.previousValue === 'string' &&
      typeof changes.controlledValue?.currentValue === 'string' &&
      changes.controlledValue.previousValue !== changes.controlledValue.currentValue
    ) {
      this.searchInputModel = changes.controlledValue.currentValue;
    }
  }

  public handleInput() {
    this.searchInput.next(this.searchInputModel);
  }

  public clearInput(event: Event): void {
    event.stopPropagation();

    this.searchInputModel = '';
    this.searchInput.next('');
  }
}
